import { RefObject, useEffect, useState } from 'react';

export const useIntersectionObserver = (
  ref: RefObject<Element> | null,
  options: IntersectionObserverInit,
): boolean => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const target = ref?.current;

    if (!target) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    }, options);

    observer.observe(target);

    return () => {
      observer.unobserve(target);
      observer.disconnect();
    };
  }, [ref, options]);

  return isIntersecting;
};
